import React, { useContext, useState } from 'react'
import { useLocation } from '@reach/router'
import UserContext from '../../../UserContext'
import { TabMenuTabsProps } from '../../Common/TabMenu'
import { ServiceRequestContext } from '../ServiceRequestContext'
import ServiceComments from './ServiceComments'
import { TabItem, TabPanel, Tabs, TabsContent } from 'react-foundation'
import { SaveEvent, TabChangeEvent } from '../../Common/AnalyticsEvents'

const CommentsPane: React.FC = () => {
    const user = useContext(UserContext)
    const { pathname } = useLocation()
    const { selectedService } = useContext(ServiceRequestContext)
    const [activeTab, setActiveTab] = useState('Additional Info')

    const tabs: TabMenuTabsProps = [
        ...selectedService ? [
            {
                title: 'Additional Info',
                //hideForRoles: [Roles.Provider],
                component: <ServiceComments isGeneralView={true} service={selectedService} />
            },
            {
                title: "Comments",
                component: <ServiceComments isGeneralView={false} service={selectedService}></ServiceComments>
            }
        ] : []
    ]

    return (
            <>
            <hr></hr>
                <Tabs>
                    {tabs.map((tab, i) => <TabItem key={i} isActive={activeTab === tab.title}>
                        <button onClick={() => {
                            SaveEvent(TabChangeEvent(user, pathname, tab.title, activeTab))
                            setActiveTab(tab.title)
                        }}>{tab.title}{tab?.titleBadgeComponent}</button>
                    </TabItem>)}
                </Tabs>
        
                <TabsContent>
                    {tabs.map((tab, i) => (
                        <TabPanel key={i} isActive={activeTab === tab.title}>
                            {tab?.component}
                        </TabPanel>
                    ))}
                </TabsContent>
            </>
      
    )
}

export default CommentsPane
